import React, { Component } from 'react';
import {withRouter, Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import SideBanners from "./sidebanners";
import * as wActs from "../actions/website-actions";
import {isMobile} from 'react-device-detect';
import {FormattedMessage} from "react-intl";

class Sitemenu extends Component {

  handleClick(evt,loadP) {
    if (loadP) {
      //setTimeout(() => this.props.dispatch(pActs.changeProfiles()), 100);
    }
    if(!wActs.isNullOrUndefined(window)) {
      if(window.innerWidth <= 767) {
        window.HideCats('#showCats');
      }
    }
  }

  renderMenus() {
    //var _self = this;
    let outers = [];
    if(typeof this.props.Menu !== "undefined") {
      Object.keys(this.props.Menu).map((key) => {
        if(key.toLowerCase() !== "header" && key.toLowerCase() !== "footer" && key.toLowerCase() !== "filter") {
          //console.log(this.props.Menu[key]);
          outers.push(this.props.Menu[key][0]);
        }
        return null;
      });

      const outersSorted = (outers).sort((a,b) => { return a.Index > b.Index; });
      //let rSrc = [];

      let ri = 0;
      if(!wActs.isNullOrUndefined(outersSorted)) {
        return outersSorted.map((menu, i) => {
          let finalMenu = {...menu};
          let act = ri === 0 ? "active" : "";
          let lang = "";
          if(wActs.isNullOrUndefined(menu.Menu)) { return null;}
          const pMenu = this.props.PageMenu;
          if(!wActs.isNullOrUndefined(pMenu) && !wActs.isNullOrUndefined(pMenu[menu.Name])) { //Exist In Page Response?
            finalMenu.Menu = pMenu[menu.Name]; //Then Replace
          } //Else Use Whats Given

          if(wActs.isNullOrEmpty(finalMenu.Menu) || finalMenu.Menu.length<=0) {
            return null;
          }

          ri++;
          return (
            <li key={"sMenu" + i} className={`has-child ${act}`}><span title={menu.Description} className={"expand-child " + this.props.Settings.LocalCSS} style={{cursor: "pointer"}}>{menu.Title}</span>
              <ul className={"sub-categories " + act}>
                {
                  finalMenu.Menu.map((smenu) => {

                    let path = wActs.isNullOrUndefined(smenu.Page) ? "" : smenu.Page.Path;
                    let target = "_self";
                    let cde;

                    if(wActs.isNullOrEmpty(path)) {
                      if(!wActs.isNullOrUndefined(smenu.Settings)) {
                        path = smenu.Settings.Url;
                        target = "_blank";
                      }
                    }
                    if(wActs.isNullOrUndefined(path)) {
                      //console.log("Menu Item, could not determine page: ", smenu);
                      return null;
                      //path ="/"
                    }
                    if(target==="_self") {
                      cde = <li key={`sMenu.${smenu.Name}.li.${i}`}><Link onClick={(evt) => { this.handleClick(evt, true) }} to={path} key={`sMenu.${smenu.Name}.hr.${i}`} title={smenu.Description}>{smenu.Title}{smenu.Count && <span style={{ color: "#f41161", marginLeft: "3px", display: "inline", fontSize: "1.1rem", border: "none" }}>({smenu.Count})</span>}</Link></li>;
                    } else {
                      cde = <li key={`sMenu.${smenu.Name}.li.${i}`}><a key={`sMenu.${smenu.Name}.hr.${i}`} href={path} target={target} title={smenu.Description}>{smenu.Title}{smenu.Count && <span style={{ color: "#f41161", marginLeft: "3px", display: "inline", fontSize: "1.1rem", border: "none" }}>({smenu.Count})</span>}</a></li>;
                    }

                    return cde;
                  })
                }
              </ul>
            </li>
          );
        });

      }
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(typeof window !== "undefined") {
      window.ResetMenu();
    }
  }


  render() {

    return (
      <div>
        {!this.props.WebPage.UCMode &&
          <div className={`expand-sidebar ${this.props.Classnames}`} id={"showCats"}>
            <h4><FormattedMessage id={"menu.showcatagories"}>{(...content) => content}</FormattedMessage></h4>
          </div>

        }
        <div className="sidebar left to-be-expanded">
          {!this.props.WebPage.UCMode &&
            <div className="categories-wrapper">
              <ul>
                {this.renderMenus()}
              </ul>
            </div>
          }
          <SideBanners Classnames="banner-wrapper " Id={"Adserver-250x200-sidebar1"} Repeat={2} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Menu: state.Website.Menu,
    Settings: state.Website.Settings,
    WebPage: state.Website,
    PageMenu: state.Website.Page.Menu,
  };
}

export default connect(mapStateToProps)(Sitemenu);
